import { CircularProgress, Grid } from "@mui/material";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import MajorTopicBox from "pages/SkusPage/SkuMajorTopics/SkuMajorTopicBox";
import {
  ListRequestOfBaseFilter,
  ListResponseOfSkuMajorTopic,
  Skus,
} from "services/KnowfullyAdminClient";

const SkuMajorTopicsList = ({
  skuId,
  sku,
}: {
  skuId: string;
  sku: Skus | undefined;
}) => {
  const { skuService } = useGlobalContext();

  const { data, isFetching } = useStrictQuery<ListResponseOfSkuMajorTopic>(
    ["skuMajorTopics", skuId],
    () =>
      skuService.getSkuMajorTopics(
        skuId,
        ListRequestOfBaseFilter.fromJS({
          sortField: "createdOn",
          sortDescending: true,
        })
      ),
    { enabled: !!skuId && !!sku }
  );

  const renderMajorTopics = () =>
    data?.data?.map((skuMajorTopic, i) => (
      <MajorTopicBox
        key={skuMajorTopic.id}
        skuMajorTopic={skuMajorTopic}
        sku={sku!}
        showActions={false}
        index={i}
      />
    ));

  return (
    <>
      {isFetching ? (
        <CircularProgress style={{ float: "left" }} size={24} />
      ) : (
        <Grid container>{renderMajorTopics()}</Grid>
      )}
    </>
  );
};

export default withErrorBoundary(SkuMajorTopicsList);
